import { erpAxios } from '.';

const fetchEmployees = async () => {
  const { data } = await erpAxios(`radnici/mobile`);
  return data;
};

export default fetchEmployees;
